<div [hidden]="hideDr" class="col mb-3">
  <label class="form-label">DR<span [hidden]="!requireDr">*</span></label>
  <select2 [resettable]="resettable" [(ngModel)]="drSelected" [multiple]="multiDr" placeholder="Seleccionar DR" (update)="selectDR()" [data]="drData" [required]="requireDr"></select2>
</div>
<div [hidden]="hideSector" class="col mb-3">
  <label class="form-label">Sector<span [hidden]="!requireSector">*</span></label>
  <select2 [resettable]="resettable" [(ngModel)]="sectorSelected" [multiple]="multiSector" placeholder="Seleccionar sector" (update)="selectSector()" [data]="sectorData" [required]="requireSector"></select2>
</div>
<div [hidden]="hideVnPlate" class="col mb-3">
  <label class="form-label">Placas VN<span [hidden]="!requireVnPlate">*</span></label>
  <select2 [resettable]="resettable" [(ngModel)]="vnPlateSelected" [multiple]="multiVnPlate" placeholder="Seleccionar placa VN" (update)="selectVnPlate()" [data]="vnPlateData" [required]="requireVnPlate"></select2>
</div>
<div [hidden]="hidePvGroup" class="col mb-3">
  <label class="form-label">Grupo PV<span [hidden]="!requirePvGroup">*</span></label>
  <select2 [resettable]="resettable" [(ngModel)]="grupopvSelected" [multiple]="multiPvGroup" placeholder="Seleccionar grupo PV" (update)="selectGroupPV()" [data]="grouppvData" [required]="requirePvGroup"></select2>
</div>
<div [hidden]="hideSectionPv" class="col mb-3">
  <label class="form-label">Sección PV<span [hidden]="!requireSectionPv">*</span></label>
  <select2 [resettable]="resettable" [(ngModel)]="sectionpvSelected" [multiple]="multiSectionPv" placeholder="Seleccionar sección PV" (update)="selectSectionPV()" [data]="sectionpvData" [required]="requireSectionPv"></select2>
</div>
<div
  [hidden]="hideDistri"
  [class.col]="variant === 'default'"
  [class.mb-3]="variant === 'default'"
  [class.distributor-filter-installation]="variant === 'topbar'">
  @if (variant === 'topbar') {
    <span class="distributor-filter-installation-icon" aria-hidden="true"></span>
  } @else {
    <label class="form-label"><span class="visually-hidden">Nº de cuenta Punto de Red</span><span [hidden]="!requireDistri">*</span></label>
  }
  <select2
    id="distributor-filter-select"
    class="distributor-filter-select"
    [overlay]="variant === 'topbar'"
    [selectionNoWrap]="variant === 'topbar'"
    [styleMode]="variant === 'topbar' ? 'borderless' : 'default'"
    [resettable]="resettable"
    [(ngModel)]="installationSelected"
    [multiple]="multiDistri"
    [placeholder]="variant === 'topbar' ? 'Seleccionar concesionario' : 'Seleccionar Punto de Red'"
    (update)="selectInstallation()"
    [data]="distributorData"
    [required]="requireDistri"
    [class.is-invalid]="requireDistri && modelFilter.Installation.length === 0">
  </select2>
  @if (variant === 'default') {
    <div class="invalid-feedback" style="top:auto !important">
      <div [hidden]="!requireDistri">
        Punto de Red requerido
      </div>
    </div>
  }
</div>
@if (!selectOnChange || !hideResetFilter) {
<div class="col w-auto mb-3">
  @if (!selectOnChange) {
  <button type="button" class="btn btn-primary" (click)="emitFilter()">Filtrar</button>
  }
  @if (!hideResetFilter) {
  <button type="button" class="btn btn-outline-secondary ms-2" (click)="emitReset()">Limpiar filtros</button>
  }
</div>
}
